import { LicenceDetailsState } from '@urbanx/agx.agencies.client';
import { nswAgreementOptions } from './nswAgreementOptions';
import { qldAgreementOptions } from './qldAgreementOptions';

export const getAgreementOptions = (companyState: string | number) => {
  switch (companyState) {
    case LicenceDetailsState.QLD.toString():
    case LicenceDetailsState.QLD: {
      return qldAgreementOptions;
    }
    case LicenceDetailsState.NSW.toString():
    case LicenceDetailsState.NSW: {
      return nswAgreementOptions;
    }
    default:
      return [];
  }
};
